<template>
  <div class="u-tipBox" v-if="tipStyle">
    <div class="tipBox-wrap">
      <div class="tipBox">
        <div class="tip_content">
          <div class="tip_title">{{title}}</div>
          <img :src="tip_img" class="tip_img" :class="tipStyle===1 ? 'tip_img2' : ''">
          <div class="wirte_tip2" v-if="tipStyle===4">中奖信息可到锦囊查询哦～</div>
          <div class="wirte_tip2" v-if="tipStyle===2">红包将于三小时内到账</div>
          <div class="wirte_tip" v-if="tipStyle===5">中奖信息可以在活动首页的锦囊中查看<br>奖品将于活动结束后15个工作日内派送<br>请注意查看信息</div>
        </div>
        <img :src="btn_img" class="tip_btn1" @click="tipBtn">
        <img src="../../assets/again.png" class="tip_btn2" @click="againGame" v-show="tipStyle !== 1">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'u-tipBox',
  data () {
    return {
      // tipStyle: 1, // 1实物奖品，2红包，3无中奖，4无机会，5填写成功
      // awardName: '圣诞盲盒 一套',
      title: '',
      tip_img: '',
      btn_img: '',
      toShow: false
    }
  },
  props: ['tipStyle', 'awardName'],
  watch: {
    tipStyle (val, oldVal) {
      this.setImg()
    }
  },
  mounted () {
    console.log(this.tipStyle, this.awardName)
    this.setImg()
  },
  methods: {
    againGame () {
      if (this.tipStyle === 2) {
        this.$stat({ event: 'again_luck' }) // 上报事件
      } else {
        this.$stat({ event: 'again_unluck' }) // 上报事件
      }
      this.$router.replace({ path: '/home' })
    },
    tipBtn () {
      switch (this.tipStyle) {
        case 1:
          this.$stat({ event: 'get_gift' }) // 上报事件
          break
        case 2:
          this.$stat({ event: 'share_luck' }) // 上报事件
          break
        case 3:
          this.$stat({ event: 'call_friend' }) // 上报事件
          break
        case 4:
          this.$stat({ event: 'share_nochange' }) // 上报事件
          break
      }
      if (this.tipStyle === 1) {
        this.$router.replace({ path: '/phone' })
      } else {
        this.$router.replace({ path: '/poster' })
      }
    },
    setImg () {
      switch (this.tipStyle) {
        case 1:
          this.title = `恭喜你获得${this.awardName}`
          this.tip_img = require('../../assets/get_img.png')
          this.btn_img = require('../../assets/getGift.png')
          break
        case 2:
          this.title = `恭喜你获得${this.awardName}`
          this.tip_img = require('../../assets/get_redbag.png')
          this.btn_img = require('../../assets/call.png')
          break
        case 3:
          this.title = '很遗憾！错过礼物了！'
          this.tip_img = require('../../assets/unluck.png')
          this.btn_img = require('../../assets/call.png')
          break
        case 4:
          this.title = '你已经抽过奖啦！'
          this.tip_img = require('../../assets/no_change.png')
          this.btn_img = require('../../assets/call.png')
          break
        case 5:
          this.title = '填写成功'
          this.tip_img = require('../../assets/no_change.png')
          this.btn_img = require('../../assets/call.png')
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.u-tipBox{
}
.tipBox-wrap{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 3;
  .tipBox{
    width:730px;
    height: 690px;
    position: absolute;
    bottom: 62%;
    transform: translateY(50%);
    left: 10px;
    background:url('../../assets/tipBox.png') no-repeat;
    background-size: 100%;
    .tip_content{
      position: absolute;
      top: 190px;
      left: 11%;
      width: 78%;
      height: auto;
    }
    .tip_title{
      font-size: 40px;
      font-weight: bold;
      color: #F42D00;
      width: 100%;
      text-align: center;
    }
    .tip_img{
      width: 258px;
      height: auto;
      margin:auto;
      margin-top: -26px;
      display: block;
    }
    .tip_img2{
      width: 328px;
    }
    .wirte_tip{
      text-align: center;
      color: #333;
      font-size: 19px;
      line-height: 1.2;
      margin-top: -30px;
    }
    .wirte_tip2{
      text-align: center;
      color: #333;
      font-size: 19px;
      line-height: 1.2;
      margin-top: -10px;
    }
    .tip_btn1{
      position: absolute;
      width: 318px;
      height: auto;
      bottom: -20px;
      right: 50%;
      transform: translateX(50%);
    }
    .tip_btn2{
      position: absolute;
      width: 318px;
      height: auto;
      bottom: -150px;
      right: 50%;
      transform: translateX(50%);
    }
  }
}
</style>
